import classNames from "classnames";
import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";

import { useNavigate } from "react-router-dom";
import Common_Banner from "../common-components/common-banner/Common_Banner";
import Send_message from "../common-components/common-btn/send_message/Send_message";
import Full_screen_modal from "../common-components/full_screen_modal/Full_screen_modal";
import { Success_lottie } from "../lotties/success_lottie/Success_lottie";
import Contact_map from "./contact_map/Contact_map";
import "./Contact_us.css";

const Contact_us = () => {

  const [formSubmitted, setFormSubmitted] = useState(false);

  const onSubmit = async (data) => {
    console.log("Form submitted with:", data);

    const htmlFormat = ` <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #eee; border-radius: 8px; max-width: 600px; margin: auto;">
          <h2 style="color: #4CAF50; border-bottom: 2px solid #4CAF50; padding-bottom: 8px;">
            📩 New Contact Form Submission
          </h2>
          <p style="font-size: 16px; margin: 10px 0;">You’ve received a new enquiry from your website:</p>
          <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Name</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.name}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Email</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.email}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Message</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.message}</td>
            </tr>
          </table>
        </div>`;

    try {
      const payload = {
        email: "aditya.jagtap@profcyma.in",
        subject: "demo",
        html: htmlFormat,
        key: "Profcyma",
      };

      const response = await fetch(
        "https://emailservices.hostelbliss.com:3301/common-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setShowModal(true);
        setTimeout(() => {
          navigate("/");
          setShowModal(false);
        }, 2500);
      } else {
        console.error("Form submission failed:", result);
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();


  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: "Home", link: "/contact-us", isActive: false },
    { label: "CONTACT US", link: "", isActive: true },
  ];
  return (
    <section className="Contact_us">
      <Common_Banner
        imgSrc={"/assets/images/contact-us/contact-banner.png"}
        title_text="Contact Us"
        breadcrumbs={breadcrumbs}
      />
      <div className="contact-section">
        {/* Contact Info Section */}
        <Container>
          <div className="contact-div">
            <div className="card-div">
              <Row className="justify-content-center">
                <Col md={4} sm={6} className="mb-4">
                  <div className="contact-card">
                    <div className="icon-circle">
                      <img
                        src="./assets/images/logo/path.png"
                        className="icons"
                      />
                    </div>
                    <h5>Location</h5>
                    <p>
                      Swami Vivekanand Sports Club, LMD Chowk, Bavdhan &
                      Ganga Legend Sports Ground, Bavdhan
                    </p>
                  </div>
                </Col>

                <Col md={4} sm={6} className="mb-4">
                  <div className="contact-card">
                    <div className="icon-circle">
                      <img
                        src="./assets/images/logo/mail.png"
                        className="icons"
                      />
                    </div>
                    <h5>Email Address</h5>
                    <p>isramitb@gmail.com</p>
                  </div>
                </Col>

                <Col md={4} sm={6} className="mb-4">
                  <div className="contact-card">
                    <div className="icon-circle">
                      <img
                        src="./assets/images/logo/phone-call.png"
                        className="icons"
                      />
                    </div>
                    <h5>Phone Number</h5>
                    <p>+91 9096247296</p>
                  </div>
                </Col>
              </Row>
            </div>

            {/* Get in Touch Form */}
            <Row className="justify-content-center ">
              <Col md={8}>
                <div className="contact-form-card">
                  <h3 className="form-title">Get in Touch</h3>

                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter Full Name*"
                        {...register("name", {
                          required: "Name is required",
                        })}
                        className={classNames("form-input", {
                          "is-valid": getValues("name"),
                        })}
                      />
                      {errors?.name && (
                        <span className="invalid-feedback d-block">
                          {errors.name.message}
                        </span>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        name="email"
                        placeholder="Enter Email*"
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            message: "Invalid email address",
                          },
                        })}
                        className={classNames("form-input", {
                          "is-invalid": errors?.email,
                          "is-valid": getValues("email"),
                        })}
                      />
                      {errors?.email && (
                        <span className="invalid-feedback d-block">
                          {errors.email.message}
                        </span>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Control
                        as={"textarea"}
                        type="text"
                        name="message"
                        placeholder="Write your message here"
                        {...register("message", {
                          required: "Message is required",
                        })}
                        className={classNames("form-input", {
                          "is-invalid": errors?.message,
                          "is-valid": getValues("message"),
                        })}
                      />
                      {errors?.message && (
                        <span className="invalid-feedback d-block">
                          {errors.message.message}
                        </span>
                      )}
                    </Form.Group>
                    <div className="button">
                      {!formSubmitted && (
                        <Send_message
                          type="submit"
                          showArrow={false} />
                      )}
                    </div>
                  </Form>

                </div>  
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      <Contact_map />
      <Full_screen_modal
        show={showModal}
        onHide={() => setShowModal(false)}
        lottie={<Success_lottie />} />

    </section>
  );
};

export default Contact_us;
